
export const SOFTLINE_API_ABAU_DOCUMENT_QUERY = 'document-query/document/query/{{type}}';
export const SOFTLINE_API_ABAU_DESPATCHADVICE_LINKS =
  '/despatchadvice-link/despatchadvice-link/links';
export const SOFTLINE_API_ABAU_DESPATCHADVICE_LINK =
  '/despatchadvice-link/despatchadvice-link/links/{{invoiceVerificationId}}';
export const SOFTLINE_API_ABAU_DOCUMENT_HEAD = '/v1/belege/entities/{{id}}';
export const SOFTLINE_API_ABAU_ARCHIVE_DOWNLOAD = '/v1/archive/download/{{fileKey}}';
